import buttons from "./buttons";
import flags from "./lang_selection";

const components = {
  buttons,
  flags,
};

export default components;
